import React from 'react';
import { useDispatch } from 'react-redux';
import { Button } from '@mui/material';

import { Icon, showConfirmCancelDialog, useSettings, Utils } from 'app/main/components';
import { DetailsSectionWrapper } from 'app/main/components/page-layouts';

interface DemsDetailsSectionDeleteRecipientsProps {
	demsUid: string;
	isLoading: boolean;
	updateRefresh: VoidFunction;
}

export default function DemsDetailsSectionDeleteRecipients(props: DemsDetailsSectionDeleteRecipientsProps) {
	const dispatch = useDispatch();
	const { t } = useSettings();

	const confirmSelection = () => {
		dispatch(
			showConfirmCancelDialog({
				title: t('DIALOG_EMPTY_LIST'),
				onConfirm: () =>
					Utils.executeStored({
						action: `st_dems_recipients_delete`,
						dispatch,
						data: { derc_dems_uid: props.demsUid },
						successHandler: () => {
							dispatch(Utils.alertSuccessMsg(t));
							props.updateRefresh();
						}
					})
			})
		);
	};

	return (
		<DetailsSectionWrapper
			title={t('DEMS_SECTION_EMPTY_TITLE')}
			actions={
				<Button startIcon={<Icon icon="delete" />} onClick={confirmSelection} disabled={props.isLoading}>
					{t('DEMS_SECTION_EMPTY_BUTTON_CLEAR')}
				</Button>
			}
		>
			{t('DEMS_SECTION_EMPTY_DESCRIPTION')}
		</DetailsSectionWrapper>
	);
}
